import { t } from "i18next";
import DBButton from "../../component/global/DBButton";
import DBModal from "../../component/global/DBModal";

const GUIDE_SECTIONS = [
    "paths",
    "define",
    "fields",
    "campaign",
    "send",
    "channels",
    "phone",
];

export default function SurveyGuideModal({ show, onHide }) {
    return (
        <DBModal
            permanent
            show={show}
            minWidth={640}
            onHide={onHide}
            className="survey-settings-help-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                closeLabel={t("survey.settings.help.close")}
                title={t("survey.guide.title")}
            />
            <DBModal.Content>
                <div className="survey-settings-help">
                    {GUIDE_SECTIONS.map((section) => (
                        <section key={section}>
                            <h5>{t(`survey.guide.${section}.title`)}</h5>
                            <p>{t(`survey.guide.${section}.body`)}</p>
                        </section>
                    ))}
                </div>
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("survey.settings.help.close")}
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
